import { Component, inject } from '@angular/core';
import { ConfirmService } from '../../../services/confirm.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  private confirm = inject(ConfirmService);
  readonly request = this.confirm.request;

  cancel() {
    this.confirm.resolve(false);
  }
  ok() {
    this.confirm.resolve(true);
  }
  stopProp(e: Event) {
    e.stopPropagation();
  }
}
